import { RouteConfig } from 'vue-router'

import {
	DailyControlsIndex,
    LunchControlsIndex,
    PermissionControlsIndex,
    LoanControlsIndex,
    AdvanceControlIndex,
    CuartaCategoriaIndex,
    LiquidacionControlIndex,
    BondControlIndex,
    DiscountControlIndex,
    BondControlMassiveList,
    CreateBondControlMassive
} from '@/views'

const dailycontrolsRouter: Array<RouteConfig> = [
	{
        path: 'daily-controls',
        name: 'daily-controls',
        component: DailyControlsIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Control Diario de Empleados'
        }
    },
    {
        path: 'lunch-controls',
        name: 'lunch-controls',
        component: LunchControlsIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Control de Refrigerio de Empleados'
        }
    },
    {
        path: 'permission-controls',
        name: 'permission-controls',
        component: PermissionControlsIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Control de Permisos'
        }
    },
    {
        path: 'loan-controls',
        name: 'loan-controls',
        component: LoanControlsIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Control de Prestamos'
        }
    },
    {
        path: 'advance-control',
        name: 'advance-control',
        component: AdvanceControlIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Control de Adelantos'
        }
    },
    {
        path: 'cuarta-categoria',
        name: 'cuarta-categoria',
        component: CuartaCategoriaIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Control de bonos de 4ta Cat.'
        }
    },
    {
        path: 'bond-control',
        name: 'bond-control',
        component: BondControlIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Control de Bonos'
        }
    },
    {
        path: 'bond-control-massive',
        name: 'bond-control-massive',
        component: BondControlMassiveList,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Control de Bonos'
        }
    },
    {
        path: 'bond-control-massive/create',
        name: 'bond-control-massive-create',
        component: CreateBondControlMassive,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Crear control de bonos masivos'
        }
    },
    {
        path: 'bond-control-massive/edit/:headquarter/:area/:sub_area/:year/:month/:fortnight/:bondTypeId',
        name: 'bond-control-massive-edit',
        component: CreateBondControlMassive,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Crear control de bonos masivos'
        }
    },
    {
        path: 'discount-control',
        name: 'discount-control',
        component: DiscountControlIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Control de Descuentos'
        }
    },
    {
        path: 'liquidacion-control',
        name: 'liquidacion-control',
        component: LiquidacionControlIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Control de Liquidaciones'
        }
    }
]

export default dailycontrolsRouter
